import React from 'react';
import clsx from 'clsx';
import GameBoard from './components/GameBoard/GameBoard';

const minesCount = 8;
const rowsCount = 10;
const colsCount = 8;

export interface AppProps {}

const App: React.FC<AppProps> = () => {
  return (
    <div
      className={clsx(
        'h-screen',
        'bg-gradient-to-tr from-purple-400 via-pink-500 to-red-500  text-white',
      )}
    >
      <GameBoard
        minesCount={minesCount}
        rowsCount={rowsCount}
        colsCount={colsCount}
      />
    </div>
  );
};

export default App;
